import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ResponseAvmData } from '../../models/response-avm-data';

@Component({
  selector: 'app-response-avm-api',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './response-avm-api.component.html'
})
export class ResponseAvmApiComponent {
  @Input() response: ResponseAvmData | null = null;
  direction:any;

  ngOnChanges(){
    if(this.response?.land_frontage_direction_orientation?.length){
      this.direction={};
      this.response?.land_frontage_direction_orientation.forEach((e:any)=>{
          this.direction[Object.keys(e).toString()] = e[Object.keys(e).toString()];
      })
    }
  }
}
